import styled from "styled-components";

export const IndicatorBadgeWrapper = styled.div<{ $bgColor: string }>`
    display: flex inline;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 18px;
    height: 22px;
    padding-inline: 8px;
    align-items: center;
    background-color: ${({ $bgColor }) => $bgColor};
`;
